<template>
  <div>
    <div class="">
      <p style="margin-top: 14px; font-weight: 500; font-family: 'BrooklynSamuelsFive-Medium', monospace !important; margin-left: 24px;" class=" ml-4">As Seen & Heard</p>
      
      <div class="partnership-carousel-container">
        <div ref="carouselScrollDiv" class="partnership-carousel-wrapper" @mouseenter="pauseAutoScroll"
          @mouseleave="resumeAutoScroll">
          <div class="carousel-track" :style="{ transform: `translateX(${scrollPosition}px)` }">
            <v-card v-for="(partner, index) in partners2" :key="`first-${index}`"
              class="mx-4 d-flex align-center justify-center no-border-card carousel-item" width="170" height="100"
              elevation="0">
              <v-img :src="partner.icon" :alt="partner.name" contain class="carousel-image" />
            </v-card>

            <v-card v-for="(partner, index) in partners2" :key="`second-${index}`"
              class="mx-4 d-flex align-center justify-center no-border-card carousel-item" width="170" height="100"
              elevation="0">
              <v-img :src="partner.icon" :alt="partner.name" contain class="carousel-image" />
            </v-card>
          </div>
        </div>
      </div>
    </div>

    <v-layout _benefits row wrap
      v-scrollanim="{ bEnt: 'app-bg-white', enter: 'bg-animate app-bg-sand', offsetBottom: 200 }">
      <v-flex xs12 tag="h2" class="text-xs-center _benefits--title">
        NannyGranny connects the world's most experienced carers <br />with those who need them the most.
      </v-flex>

      <v-flex xs12>
        <v-container grid-list-lg fill-height _benefits-container>
          <v-layout v-if="$vuetify.breakpoint.smAndDown" row wrap _items-box>
            <app-window-base :items="items">
              <template slot="item" slot-scope="{item, ind}">
                <app-card-benefits :item="item" :ind="ind" class="ma-auto" />
              </template>
            </app-window-base>
          </v-layout>

          <v-layout v-else row wrap _items-box>
            <v-flex v-for="(item, i) in items" :key="i" xs12 md3>
              <app-card-benefits :item="item" />
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>

      <!--BACKGROUND ELEMENTS-->
      <div class="_benefits-bg-elements">
        <div v-parallaxxy="{ x: -0.1, y: -0.1 }" class="smooth-parallax a1">
          <app-svg-icon name="brand/NG_ACTIVE" class="active_1" />
        </div>
        <div v-parallax="$helpers.getSpeedAnimationUp()" class="smooth-parallax">
          <app-svg-icon v-if="$vuetify.breakpoint.mdAndUp" name="patterns/NG_Pattern-15" class="pattern-15"
            color="none var(--blue)" />
        </div>
        <div v-parallax="$helpers.getSpeedAnimationUp()" class="smooth-parallax">
          <app-svg-icon name="patterns/NG_Pattern-10" class="pattern-10" color="none var(--green)" />
        </div>
        <div v-parallax="$helpers.getSpeedAnimationUp()" class="smooth-parallax">
          <app-svg-icon name="brand/NG_ACTIVE" class="active_3" color="var(--green)" />
        </div>
        <app-scroll-patterns svgName="patterns/NG_Pattern-13" v-if="$vuetify.breakpoint.mdAndUp" svgTop="-30px"
          svgClass="pattern-13-new" svgRight="-70px" svgWidth="160px" svgHeight="270px" svgTransform="rotate(122deg)"
          svgColor="none var(--orange)" duration="0.2" moveX="0" moveY="2" />
      </div>
    </v-layout>
  </div>
</template>


<script>
import AppScrollPatterns from '../../../../components/app-scroll-patterns'
import AppWindowBase from '../../../../components/app-windows/app-window-base'
import AppCardBenefits from '../../../../components/app-card/app-card-benefits'

export default {
  name: 'app-home-benefits',
  components: { AppScrollPatterns, AppCardBenefits, AppWindowBase },

  data() {
    return {
      partners2: [
        { name: 'Bandt', icon: require('@/assets/img/bandt.png') },
        { name: 'Embed', icon: require('@/assets/img/image11.png') },
        
        { name: 'DEF', icon: require('@/assets/img/image9.png') },
        { name: 'Jobs', icon: require('@/assets/img/thesydney.png') },
        { name: 'XYZ', icon: require('@/assets/img/image13.png') },
        { name: 'JKL', icon: require('@/assets/img/nanny2.png') },
        
        { name: 'MNO', icon: require('@/assets/img/mediaweek.png') }, 
        { name: 'HAR', icon: require('@/assets/img/nanny3.png') },

        { name: 'ABC', icon: require('@/assets/img/image10.png') },
        { name: 'GHI', icon: require('@/assets/img/image2.png.png') },
        
        { name: 'MNO', icon: require('@/assets/img/hellocare.png') },
        // { name: 'DEF', icon: require('@/assets/img/image9.png') },
        
        { name: 'hyj', icon: require('@/assets/img/image12.png') },
        
      ],

      autoScrollInterval: null,
      scrollPosition: 0,
      scrollSpeed: 1,
      itemWidth: 202,
      isPaused: false,
    }
  },
  mounted() {
    // Initialize scroll position to show duplicated items from left
    const maxScroll = this.partners2.length * this.itemWidth
    this.scrollPosition = -maxScroll
    this.startAutoScroll()
  },
  beforeDestroy() {
    this.stopAutoScroll()
  },
  methods: {
    startAutoScroll() {
      this.autoScrollInterval = setInterval(() => {
        if (!this.isPaused) {
          // Move from left to right (negative to positive)
          this.scrollPosition += this.scrollSpeed

          // Reset when we've scrolled through all items
          const maxScroll = this.partners2.length * this.itemWidth
          if (this.scrollPosition >= 0) {
            this.scrollPosition = -maxScroll
          }
        }
      }, 12) // 60fps
    },

    stopAutoScroll() {
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval)
        this.autoScrollInterval = null
      }
    },

    pauseAutoScroll() {
      this.isPaused = true
    },

    resumeAutoScroll() {
      this.isPaused = false
    }
  },
  computed: {
    items() {
      const _items = this.$store.getters['page/content']('homepage')
        .filter(item => item.slug === 'benefits')
      _items.forEach((item) => {
        if (this.$lodash.isString(item.param)) {
          try {
            item.param = JSON.parse(item.param)
          } catch (e) {
            console.error('NG error: Benefits - Unexpected token u in JSON')
          }
        }
      })
      return _items
    }
  }
}
</script>

<style lang="stylus" scoped>
    ._benefits
        position relative
        overflow hidden
        a {
            font-size 18px
        }
        &-container
            height 410px
        &--title
            margin 45px 0 24px
        @media (min-width: 960px)
            &-container
                height 600px
            &--title
                margin 45px 0 45px

    .app-dashboard
        width 99px
        height 99px
    .partnership-carousel-container
        max-width 100%
        overflow hidden
        margin 20px 0

    .partnership-carousel-wrapper
        width 100%
        overflow hidden
        position relative
        height 160px

    .carousel-track
        display flex
        align-items center
        transition none
        will-change transform
        
    .carousel-item
        flex-shrink 0
        
    .carousel-image
        height 101px
        width auto
        max-width 180px
        transition all 0.3s ease
    .carousel-item:hover .carousel-image
        transform scale(1.5)
    .featured-heading
        font-size 1.2rem
        font-weight bold
        margin-top 16px
        color #444
        margin-bottom 20px

    @keyframes float
        0%, 100%
            transform translateY(0px)
        50%
            transform translateY(-2px)

    .carousel-item:hover
        animation float 2s ease-in-out infinite

    ._items-box
        .flex
            &:nth-child(1)
                //align-self center

            &:nth-child(2n)
                align-self flex-end

            .v-card
                background transparent

    ._benefits-bg-elements
        width 100%
        .svg-icon
            position absolute

            &.active_1
                // top 70px
                top -452px
                right -10px
                width 60px
                height 60px
                color var(--yellow)
                @media (min-width: 960px)
                    // top 184px
                    top -520px
                    left 35%
                    width 83px
                    height 71px

            &.active_3
                top -24px
                right -10px
                width 60px
                height 60px
                transform rotate(75deg)
                color var(--green)
                @media (min-width: 960px)
                    // top 184px
                    top -24px
                    left 51%
                    width 83px
                    height 71px

            &.active_2
                // bottom 130px
                bottom 0px
                left 56%
                width 88px
                height 76px
                transform rotate(75deg)
                color var(--green)

            &.pattern-15
                right -50px
                // top 125px
                top -610px
                width 160px
                height 270px

            &.pattern-10
                left -70px
                bottom -60px
                // bottom 0px
                width 140px
                height 160px
                @media (min-width: 960px)
                    left -60px
                    // bottom 110px
                    bottom 0px
                    width 160px
                    height 270px

            &.pattern-13
                right -70px
                // bottom -16px
                top -30px
                width 160px
                height 270px
                transform rotate(122deg)

</style>



// WEBPACK FOOTER //
// src/views/app/home/components/app-home-benefits.vue